import * as React from "react";

function YouMayAlsoLikePlaceholder() {

	return (
		<div className="c-basket__upsell">
			<div className="c-basket__upsell-row">
				<h2 className="c-basket__upsell-title c-carousel-paging__container">You may also like</h2>
				<div className="c-load-content-placeholder">
					<div className="c-load-content-placeholder__item c-load-content-placeholder__item--ymal-basket"></div>
					<div className="c-load-content-placeholder__item c-load-content-placeholder__item--ymal-basket"></div>
					<div className="c-load-content-placeholder__item c-load-content-placeholder__item--ymal-basket noMobile"></div>
					<div className="c-load-content-placeholder__item c-load-content-placeholder__item--ymal-basket noMobile"></div>
				</div>
			</div>
		</div>
	);
}

export default YouMayAlsoLikePlaceholder;
